export const TABS = {
  PERSONAL_INFO: "Personal Info",
  CREDIT_CARD: "Card",
  TOMO_BOOST: "Boost",
};
